import { c as _c } from "react/compiler-runtime";
import { Center } from '@chakra-ui/react';
import { WIL_DISPLAY_NAME } from '@src/components/sco/Advisors/constants';
import { FREE_WIL_MESSAGE_LIMIT, useAdvisorsAccess, WIL_AI_UPGRADE_PRODUCT_ID } from '@src/components/sco/Advisors/model/access';
import { ConversionGate } from '@src/components/sco/Conversion/controller/ConversionGate';
type WilMessagePaywallProps = {
  /** Messages already used (for progress copy). */
  usedMessages?: number;
  remainingMessages?: number;
  /** Server allotment (`advisorWilMessageUsage.limit`); falls back to this environment's meter. */
  limit?: number;
  /** Compact banner vs full card for composer replacement. */
  variant?: 'card' | 'banner';
};

/**
 * Wil.ai free-message meter and lock. Startups Pro (`canAccessChat`) removes the cap; the
 * Conversion gate prices it from the catalog and opens the checkout for that plan.
 */
export const WilMessagePaywall = t0 => {
  const $ = _c(11);
  const {
    limit: limitProp,
    remainingMessages: t1,
    usedMessages,
    variant: t2
  } = t0;
  const remainingMessages = t1 === undefined ? 0 : t1;
  const variant = t2 === undefined ? "card" : t2;
  const {
    freeWilMessageLimit
  } = useAdvisorsAccess();
  const limit = limitProp || freeWilMessageLimit || FREE_WIL_MESSAGE_LIMIT;
  const used = usedMessages ?? Math.max(0, limit - remainingMessages);
  const isExhausted = remainingMessages <= 0;
  const t3 = String(limit);
  let t4;
  if ($[0] !== t3) {
    t4 = {
      intent: "wil-limit" as const,
      permission: "canAccessChat" as const,
      productId: WIL_AI_UPGRADE_PRODUCT_ID,
      tokens: {
        messageCount: t3
      }
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const gateArgs = t4;
  if (variant === "banner" && !isExhausted) {
    let t5;
    if ($[2] !== limit || $[3] !== used) {
      t5 = {
        used,
        limit,
        unit: "free messages"
      };
      $[2] = limit;
      $[3] = used;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== gateArgs || $[6] !== t5) {
      t6 = <ConversionGate {...gateArgs} ctaLabel="Upgrade for unlimited" density="meter" meter={t5} />;
      $[5] = gateArgs;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  const t5 = isExhausted ? undefined : `Keep chatting with ${WIL_DISPLAY_NAME}`;
  let t6;
  if ($[8] !== gateArgs || $[9] !== t5) {
    t6 = <Center paddingY={4}><ConversionGate {...gateArgs} assurance="Cancel anytime" density="boxed" headline={t5} /></Center>;
    $[8] = gateArgs;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};